import apiClient from '@/services/api';
import type {
  StoryTimeGenerateRequest,
  StoryTimeGenerateResponse,
  StoryTimeSessionHistoryResponse,
  StoryTimeSessionsParams,
  StoryTimeAudioResponse,
} from '@/types/storytime.types';

export const generateStory = async (
  request: StoryTimeGenerateRequest
): Promise<StoryTimeGenerateResponse> => {
  const { data } = await apiClient.post<StoryTimeGenerateResponse>('/storytime/generate', request);
  return data;
};

export const getStorySessions = async (
  params: StoryTimeSessionsParams = {}
): Promise<StoryTimeSessionHistoryResponse> => {
  const { data } = await apiClient.get<StoryTimeSessionHistoryResponse>('/storytime/sessions', {
    params,
  });
  return data;
};

export const deleteStorySession = async (sessionId: string): Promise<void> => {
  await apiClient.delete(`/storytime/sessions/${encodeURIComponent(sessionId)}`);
};

export const generateStoryAudio = async (
  sessionId: string,
  language: string
): Promise<StoryTimeAudioResponse> => {
  const { data } = await apiClient.post<StoryTimeAudioResponse>(
    `/storytime/sessions/${encodeURIComponent(sessionId)}/audio`,
    { language }
  );
  return data;
};

export const fetchStoryAudioBlob = async (sessionId: string): Promise<Blob> => {
  const { data } = await apiClient.get<Blob>(
    `/storytime/sessions/${encodeURIComponent(sessionId)}/audio/stream`,
    { responseType: 'blob' }
  );
  return data;
};
